import { HttpService, HttpServiceResponse } from '../shared'
import { PermissionsServerData } from './permission.types'

export class PermissionProvider {
  private get url(): string {
    return `${this.baseUrl}/perms_api.php`
  }

  constructor(private http: HttpService, private baseUrl: string) {}

  public get(): Promise<HttpServiceResponse<PermissionsServerData>> {
    return this.http.post(`${this.url}`)
  }
}
